import { createContext } from 'react'
import { TopicPageMode } from './TopicDetailPage'
import { IOptionResponse, IQuizResponse } from 'types/Topic'
import {
  OpenTopicEnrolmentThroughPathwayQuery,
  PathwayNextTopicFragment,
  TopicWithEnrolmentFragment,
  TopicWithVersion_TopicModelAsEditor_Fragment,
  TopicWithVersionFragment
} from './TopicDetailPage.codegen'
import { TopicVersionModelAsEditor } from '../../graphql/private/PrivateSchemaTypes'
import { TypeOfElement } from 'types/generic'

export type TopicDetail = (
  | TopicWithEnrolmentFragment
  | TopicWithVersionFragment
) & {
  draftVersion?: Partial<TopicVersionModelAsEditor>
} & {
  enrolmentOrSelfEnrol?:
    | TopicWithEnrolmentFragment['enrolmentOrSelfEnrol']
    | null
} & {
  topicVersions?: TopicWithVersion_TopicModelAsEditor_Fragment['topicVersions']
}

export type TopicDetailTopicVersion =
  | TopicDetail['draftVersion']
  | TypeOfElement<TopicDetail['topicVersions']>

export type TopicDetailContextType = {
  mode: TopicPageMode
  updateTopicProgress: (elementId: number) => void
  resetEnrolment: () => void
  saveFreeQuizResponse: (
    elementId: number,
    response: string
  ) => Promise<IQuizResponse>
  saveQuizResponse: (
    elementId: number,
    optionResponses: IOptionResponse[]
  ) => Promise<IQuizResponse | null>
  isLoading: boolean
  topic: TopicDetail
  pathway?: OpenTopicEnrolmentThroughPathwayQuery['pathway'] | null
  nextInPathway?: PathwayNextTopicFragment | null
  topicVersion: TopicDetailTopicVersion
}

export const TopicDetailContext = createContext<TopicDetailContextType>(
  null as any as TopicDetailContextType
)
